<!-- компонент Role: отдельная нестандартная форма редактирования роли -->
<template>
	<div v-if="this.$store.state.is_auth">

		<template v-if="!form_ErrorMessage">
			<!-- блок с локальным сообщением об ошибке -->
			<transition name="fadeControl" key="transitionError">
				<div v-show="localErrorMessage !== false" class="alert alert-danger font-size-90 margin-top-15" role="alert">
					{{ localErrorMessage | ftc }}
					<button @click="localErrorMessage = false" class="close" :title="'main/close' | ftc">×</button>
				</div>
			</transition>
			
			<!-- заголовок -->
			<h3>{{ form_GetData.title | ftc }}</h3>

			<form class="w5-from"><fieldset>
				<!-- наименование -->
				<div v-if="form_GetData && form_GetData['fields'] && form_GetData['fields']['name']" class="w5-form-row">
					<Field
						:isVisibleRow="form_GetData['fields']['name']['type'] === 'text'"
						:crud="crud"
						:action="action"
						v-model="nameValue"
						:Field="nameField"
						@focus="onFocusName"
						:removeRightPadding="true" />
				</div>

				<br>

				<!-- роли -->
				<template v-if="form_GetData && form_GetData['fields'] && form_GetData['fields']['items'] && form_GetData['fields']['items']['list_description']">
					<div v-for="(role, key) in form_GetData['fields']['items']['list_description']" class="w5-role-wrapper">
						<!-- наименование роли -->
						<div class="w5-role-item-name"><span :title="selectStatus(key, role) | ftc" @click="selectDeselect($event, key, role)">{{ role.name | ftc }}</span></div>
						<!-- разрешения для текущей роли -->
						<div class="w5-role-item-value">
							<div v-for="(item, idx) in role.actions" class="w5-checkbox">
								<label class="checkbox-inline">
									<input type="checkbox" :value="key + '/' + idx" v-model="checkValues"> {{ item | ftc }}
								</label>
							</div>
						</div>
					</div>
				</template>

				<!-- кнопка -->
				<div class="w5-field">
					<button
						type="button"
						ref="submut_button"
						@click="submitForm"
						:disabled="buttonBlock > 0 ? 'disabled' : false"
						class="btn btn-submit btn-primary w5-button-save"
						:class="{ hidden: form_Loading }">
						{{ action === 'update' ? 'main/save' : 'main/create' | ftc }}
					</button>
				</div>
			</fieldset></form>

		</template>

		<errorAlert v-else :message="form_ErrorMessage"></errorAlert>

	</div>
</template>

<script>
///////////////////////////////////////////////////////////////////////////////
import Field from '@/components/elements/formfield'
///////////////////////////////////////////////////////////////////////////////
export default {
	//=========================================================================
	// наименование
	//=========================================================================
	name: 'Role',
	//=========================================================================
	// изменяемые локальные свойства
	//=========================================================================
	data() {
		return {
			// наименование CRUD-объекта
			crud: 'role',

			// действие: create | update
			action: null,

			// ID редактируемого объекта
			id: null,

			// локальное сообщение об ошибке
			localErrorMessage: false,

			// наименование роли
			nameField: {
				type: '',
				title: '',
				required: false,
				_field_name: 'name',
				_visible: true,
				_errMsg: ''
			},
			nameValue: '',

			// значения
			checkValues: [],

			// блокиовка кнопки формы
			buttonBlock: 0,

			// данные в виде FormData
			FD: false,
			FD_count: 0
		}
	},
	//=========================================================================
	// функция, которыя будет вызвана после создания компонента,
	// но перед монтированием в дом
	//=========================================================================
	created() {
		// если не авторизован - редирект на страницу логина
		if (!this.$store.state.is_auth)
		{
			// сброс аутентификации
			this.$store.commit('dropAuth')
			// запоминаем URL, что бы к нему вернуться
			this.$store.commit('setReturnURL', this.$route.path)
			// остановим Push-систему
			this.$store.commit('pushStop')
			// делаем редирект
			return this.$router.push('/login')
		}

		// инициализация начальных данных по URL
		this.initData(this.$route.path)

		// теперь можно запросить данные
		if (this.crud) this.requestData()
	},
	//=========================================================================
	// локальные методы формы
	//=========================================================================
	methods: {
		//---------------------------------------------------------------------
		// текущий статус поля с чекбоксами
		//---------------------------------------------------------------------
		selectStatus(name, role) {
			// если есть хотя бы одно значение в массиве значений
			let _isValue = false
			if (role && role['actions'])
			{
				for (let action in role['actions'])
				{
					// значение
					let _value = name + '/' + action
					// ищем в массиве
					if (this.checkValues.indexOf(_value) > -1)
					{
						_isValue = true
						break
					}
				}
			}

			return _isValue ? 'main/deselect_all' : 'main/select_all'
		},
		//---------------------------------------------------------------------
		// клик по наименованию
		//---------------------------------------------------------------------
		selectDeselect(e, name, role) {
			if (role && role['actions'])
			{
				// вычисляем еще раз статус
				let _status = this.selectStatus(name, role)
				// теперь в зависимости от статуса - правим массив значений
				for (let action in role['actions'])
				{
					// значение
					let _value = name + '/' + action
					// позиция значения в массиве
					let _idx = this.checkValues.indexOf(_value)

					// нужно убрать из массива такие значения
					if (_status === 'main/deselect_all')
					{
						// если такое значение есть
						if (_idx > -1) this.checkValues.splice(_idx, 1)
					}
					// нужно добавить все значения в массив значений
					else if (_status === 'main/select_all')
					{
						// если еще нет в массиве
						if (_idx < 0) this.checkValues.push(_value)
					}
				}
			}
		},
		//---------------------------------------------------------------------
		// подтверждение формы
		//---------------------------------------------------------------------
		submitForm(e) {
			this.localErrorMessage = false
			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			// проверим обязательное поле
			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			if (!this.nameValue.trim().length)
			{
				// ставим ошибку на поле
				this.nameField['_errMsg'] = this.localeFtc('error/required_field')
				// скролим к полю
				window.scrollTo(0, 0)
				// на этом все
				return
			}

			if (!this.checkValues.length)
			{
				// ставим ошибку на поле
				this.localErrorMessage = 'role/item_error'
				// скролим к полю
				window.scrollTo(0, 0)
				// на этом все
				return
			}

			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			// лочим кнопку
			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			if (this.buttonBlock <= 0) this.buttonBlock = 1

			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			// соберем данные
			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			// наименование
			let _data = {
				'name': this.nameValue,
				'items': []
			}
			// значения
			this.checkValues.forEach((item) => {
				_data['items'].push(item)
			})

			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			// первый запрос - GET
			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			let _url = this.APIServerUrl + this.$route.path
			this.$http.get(_url).then(
				// успешный ответ сервера
				resGet => {
					let _dt = resGet && resGet.data && typeof resGet.data === 'object' ? resGet.data : false
					if (_dt && _dt['status'] === 'form' && _dt['_csrf'] && _dt['model'])
					{
						// второй запрос - POST
						// переупакуем данные: NameForm[data[disk]] => NameForm[data][disk]
						_data = this.FD_rePack(_data)

						// готовим данные
						let _post = {
							'_csrf': _dt['_csrf']
						}
						_post[_dt['model']] = _data

						// готовим данные в виде FormData
						this.FD = new FormData()
						this.FD_count = 0
						this.FD_prepare(_post)

						// производим сам запрос
						this.$http.post(_url, this.FD_count > 0 ? this.FD : null).then(
							// успешный ответ сервера
							resPost => {
								_dt = resPost && resPost.data && typeof resPost.data === 'object' ? resPost.data : false

								// если ошибки нет
								if (_dt && _dt['status'] === 'ok')
								{
									// просто делаем редирект на список
									this.$router.push('/' + this.crud + '/list' + (this.$store.state.lastWorkedPage[this.crud] ? '/' + this.$store.state.lastWorkedPage[this.crud] : ''))
									return
								}

								// если есть ошибки и поля
								if (_dt && _dt['status'] === 'error' && _dt['fields'])
								{
									// бежим по всем полям
									for (let k in _dt['fields'])
									{
										if (_dt['fields'][k] && Array.isArray(_dt['fields'][k]) && _dt['fields'][k].length)
										{
											// если такое поле есть - ставим все сообщения
											if (k === 'name') this.nameField['_errMsg'] = this.localeFtc(_dt['fields'][k][0])
											else this.localErrorMessage = 'role/item_error'
										}
									}

									// разлочим кнопку
									this.buttonBlock = 0
									// скролим на верх
									window.scrollTo(0, 0)
									// на этом все
									return
								}

								// иная ошибка
								this.localErrorMessage = 'error/api_incorrect'
								this.buttonBlock = 0
							},
							// отрицательный ответ сервера
							resPost => {
								// ошибка
								this.localErrorMessage = 'error/api_incorrect'
								this.buttonBlock = 0
							}
						)
						// на этом все
						return
					}

					// ошибка
					this.localErrorMessage = 'error/api_incorrect'
					this.buttonBlock = 0
				},
				// отрицательный ответ сервера
				resGet => {
					this.localErrorMessage = 'error/api_incorrect'
					this.buttonBlock = 0
				}
			)

			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
		},
		//---------------------------------------------------------------------
		// фокус на поле "name"
		//---------------------------------------------------------------------
		onFocusName() {
			// чистим ошибку
			this.nameField['_errMsg'] = ''
		},
		//---------------------------------------------------------------------
		// инициализация начальных данных
		//---------------------------------------------------------------------
		initData(path) {
			// обнуляем основные значения
			this.action = null
			this.id = null
			this.localErrorMessage = false

			// парсим входящий URL
			let _urlParts = path
				.substr(path.charAt(0) === '/' ? 1 : 0)
				.split('/')
			// должны быть минимум две части
			if (_urlParts.length < 2 ||
				!_urlParts[0] || !_urlParts[0].length ||
				!_urlParts[1] || !_urlParts[1].length)
			{
				this.localErrorMessage = this.localeFtc('main/unknown_page')
				return
			}
			// только role
			if (_urlParts[0] !== this.crud)
			{
				this.localErrorMessage = this.localeFtc('main/unknown_page')
				return
			}

			// если вторая часть это не "update" и не "create"
			if (_urlParts[1] !== 'create' && _urlParts[1] !== 'update')
			{
				this.localErrorMessage = this.localeFtc('main/unknown_page')
				return
			}

			// если это "update" и нет третьего параметра
			if (_urlParts[1] === 'update' && (_urlParts[2] === undefined || _urlParts[2] === null || _urlParts[2] === ''))
			{
				this.localErrorMessage = this.localeFtc('main/unknown_page')
				return
			}

			// получим наименование действия
			this.action = _urlParts[1]

			// получим ID объекта
			if (_urlParts[2]) this.id = _urlParts[2]
		},
		//---------------------------------------------------------------------
		// запрос данных формы
		//---------------------------------------------------------------------
		requestData() {
			// URL по умолчанию
			let _url = '/' + this.crud + '/' + this.action + (this.id ? '/' + this.id : '')
			// производим сам запрос формы
			this.forms_Get(_url, false,
				// успешно получили данные
				(data) => {
					if (data && data['status'] === 'form')
					{
						// поле "name"
						this.nameField['type'] = this.form_GetData['fields']['name']['type']
						this.nameField['title'] = this.form_GetData['fields']['name']['title']
						this.nameField['required'] = this.form_GetData['fields']['name']['required']
						this.nameField['_visible'] = this.form_GetData['fields']['name']['type'] === 'text'

						if (this.form_GetData['fields']['name']['value'])
							this.nameValue = this.form_GetData['fields']['name']['value']

						// поля с чекбоксами
						if (this.form_GetData['fields']['items']['value'])
							this.checkValues = this.form_GetData['fields']['items']['value']

						// на этом все
						return
					}

					this.localErrorMessage = 'error/api_incorrect'
				},
				// провал запроса
				() => {
					this.localErrorMessage = 'error/api_incorrect'
				}
			)
		},
		//---------------------------------------------------------------------
		// NameForm[data[disk]] => NameForm[data][disk]
		//---------------------------------------------------------------------
		FD_rePack(data) {
			let k
			let n1
			let n2
			let key1
			let key2

			for (k in data) if (data.hasOwnProperty(k))
			{
				n1 = k.indexOf('[')
				if (n1 < 0) continue

				n2 = k.indexOf(']', n1)
				if (n2 < 0) continue

				key1 = k.substr(0, n1)
				key2 = k.substring(n1 + 1, n2)

				if (n2 + 1 < k.length) key2 += k.substr(n2 + 1)

				if (!data[key1]) data[key1] = {}

				data[key1][key2] = data[k]

				delete data[k]

				data[key1] = this.FD_rePack(data[key1])
			}

			return data
		},
		//---------------------------------------------------------------------
		//---------------------------------------------------------------------
		FD_prepare: function(d, key) {
			let k

			for (k in d) if (d.hasOwnProperty(k))
			{
				// если пересылают файл в форме - патч для safari 10+
				if (d[k] && key &&
					k === 'file' &&
					typeof d[k] === 'object' &&
					'name' in d[k] &&
					'size' in d[k] &&
					'type' in d[k])
				{
					this.FD.append(key + '[' + k + ']', d[k])
					this.FD_count++
					continue
				}

				// остальные поля обрабатываем по старому
				if (typeof d[k] === 'object' && d[k] && !('lastModifiedDate' in d[k]))
				{
					if (key)
					{
						this.FD_prepare(d[k], key + '[' + k + ']')
					}
					else
					{
						this.FD_prepare(d[k], k)
					}
				}
				else
				{
					if (key)
					{
						this.FD.append(key + '[' + k + ']', d[k])
					}
					else
					{
						this.FD.append(k, d[k])
					}

					this.FD_count++
				}
			}
		}

		//---------------------------------------------------------------------
	},
	//=========================================================================
	// используемые компоненты
	//=========================================================================
	components: {
		Field
	}

	//=========================================================================
}
///////////////////////////////////////////////////////////////////////////////
</script>

<style>
.w5-role-wrapper {
	display: flex;
	margin-bottom: 20px;
}

.w5-role-item-name {
	margin: 4px 0;
	min-width: 200px;
	font-weight: 500;
}

.w5-role-item-name > span {
	border-bottom: 1px dotted black;
	user-select: none;
    cursor: pointer;
}

.w5-role-item-value > div.w5-checkbox {
	display: inline-block;
    margin-top: 0;
    margin-bottom: 0;
    vertical-align: middle;
    float: left;
    margin-right: 20px;    
}

.w5-role-item-value > div.w5-checkbox > label {
	font-weight: 300;
	user-select: none;
	cursor: pointer;
}

</style>



// WEBPACK FOOTER //
// Role.vue?7161612c